const bannerInfo = {
  // text_limit
  text_limit: {
    AOM39101: {
      // (w1024)
      B004391: {
        single_line: { small: 0, midium: 15, large: 9 },
        multi_line: { small: 0, midium: 27, large: 21 },
      },
      // (w1280)
      B005391: {
        single_line: { small: 0, midium: 18, large: 11 },
        multi_line: { small: 0, midium: 34, large: 26 },
      },
      // (w1536)
      B006391: {
        single_line: { small: 0, midium: 22, large: 14 },
        multi_line: { small: 0, midium: 41, large: 31 },
      },
      // (w1792)
      B007391: {
        single_line: { small: 0, midium: 26, large: 16 },
        multi_line: { small: 0, midium: 49, large: 37 },
      },
      // (w2048)
      B008391: {
        single_line: { small: 0, midium: 30, large: 18 },
        multi_line: { small: 0, midium: 56, large: 42 },
      },
      // (w2304)
      B009391: {
        single_line: { small: 0, midium: 33, large: 21 },
        multi_line: { small: 0, midium: 63, large: 48 },
      },
      // (w2560)
      B010391: {
        single_line: { small: 0, midium: 37, large: 23 },
        multi_line: { small: 0, midium: 70, large: 53 },
      },
      // (w3072)
      B012391: {
        single_line: { small: 0, midium: 44, large: 27 },
        multi_line: { small: 0, midium: 84, large: 64 },
      },
      // (w3584)
      B014391: {
        single_line: { small: 0, midium: 53, large: 33 },
        multi_line: { small: 0, midium: 98, large: 75 },
      },
      // (w3840)
      B015391: {
        single_line: { small: 0, midium: 56, large: 35 },
        multi_line: { small: 0, midium: 105, large: 80 },
      },
      // (w4096)
      B016391: {
        single_line: { small: 0, midium: 61, large: 37 },
        multi_line: { small: 0, midium: 112, large: 85 },
      },
      // (w4608)
      B018391: {
        single_line: { small: 0, midium: 68, large: 42 },
        multi_line: { small: 0, midium: 127, large: 97 },
      },
      // (w5120)
      B020391: {
        single_line: { small: 0, midium: 76, large: 47 },
        multi_line: { small: 0, midium: 141, large: 107 },
      },
      // (w5376)
      B021391: {
        single_line: { small: 0, midium: 80, large: 49 },
        multi_line: { small: 0, midium: 148, large: 112 },
      },
    },
    AOM62501: {
      // (w640)
      B004625: {
        single_line: { small: 0, midium: 14, large: 10 },
        multi_line: { small: 0, midium: 22, large: 18 },
      },
      // (w800)
      B005625: {
        single_line: { small: 0, midium: 18, large: 13 },
        multi_line: { small: 0, midium: 27, large: 23 },
      },
      // (w960)
      B006625: {
        single_line: { small: 0, midium: 22, large: 16 },
        multi_line: { small: 0, midium: 32, large: 27 },
      },
      // (w1120)
      B007625: {
        single_line: { small: 0, midium: 26, large: 19 },
        multi_line: { small: 0, midium: 38, large: 32 },
      },
      // (w1280)
      B008625: {
        single_line: { small: 0, midium: 30, large: 22 },
        multi_line: { small: 0, midium: 50, large: 38 },
      },
      // (w1440)
      B009625: {
        single_line: { small: 0, midium: 34, large: 25 },
        multi_line: { small: 0, midium: 51, large: 43 },
      },
      // (w1600)
      B010625: {
        single_line: { small: 0, midium: 38, large: 28 },
        multi_line: { small: 0, midium: 56, large: 47 },
      },
      // (w1920)
      B012625: {
        single_line: { small: 0, midium: 46, large: 33 },
        multi_line: { small: 0, midium: 68, large: 57 },
      },
      // (w2240)
      B014625: {
        single_line: { small: 0, midium: 53, large: 39 },
        multi_line: { small: 0, midium: 79, large: 67 },
      },
      // (w2400)
      B015625: {
        single_line: { small: 0, midium: 57, large: 42 },
        multi_line: { small: 0, midium: 84, large: 71 },
      },
      // (w2560)
      B016625: {
        single_line: { small: 0, midium: 61, large: 44 },
        multi_line: { small: 0, midium: 91, large: 77 },
      },
      // (w2800)
      B018625: {
        single_line: { small: 0, midium: 67, large: 49 },
        multi_line: { small: 0, midium: 100, large: 84 },
      },
      // (w3200)
      B020625: {
        single_line: { small: 0, midium: 77, large: 56 },
        multi_line: { small: 0, midium: 114, large: 96 },
      },
      // (w3360)
      B021625: {
        single_line: { small: 0, midium: 81, large: 59 },
        multi_line: { small: 0, midium: 120, large: 101 },
      },
      // (w3840)
      B024625: {
        single_line: { small: 0, midium: 92, large: 67 },
        multi_line: { small: 0, midium: 137, large: 116 },
      },
      // (w4320)
      B027625: {
        single_line: { small: 0, midium: 104, large: 75 },
        multi_line: { small: 0, midium: 154, large: 130 },
      },
    },
  },
  text_size: {
    AOM39101: {
      single_line: { small: 0, midium: 65, large: 105 },
      multi_line: { small: 0, midium: 35, large: 46 },
    },
    AOM62501: {
      single_line: { small: 0, midium: 40, large: 55 },
      multi_line: { small: 0, midium: 27, large: 32 },
    },
  },
};

export default bannerInfo;
